import { energyApi } from "utilities/Axios";

export const getAllDataSources = () => {
  return energyApi.get(`DatasourceMeta/GetAllDatasourceMeta`);
};